<template>
  <content-dialog
    :visible.sync="modalVisible"
    max-width="500px"
  >
    <!--<editor-fold desc="Dialog Title">-->
    <template slot="dialogTitle">
      Edit Sales Representative
    </template>
    <!--</editor-fold>-->

    <!--<editor-fold desc="Dialog Content">-->
    <v-card-text class="pa-6">
      <v-subheader>
        Sales Representative
      </v-subheader>

      <assignee-modal-select
        v-model="salesRep"
        outlined
        type="staff"
        placeholder="Select new sales rep"
      />
    </v-card-text>

    <!--<editor-fold desc="Dialog Actions">-->
    <template slot="dialogActions">
      <v-spacer />
      <v-btn
        text
        color="grey"
        @click="modalVisible = false"
      >
        Cancel
      </v-btn>
      <v-btn
        color="primary"
        :loading="submitting"
        :disabled="!salesRep"
        @click="submit"
      >
        <v-icon
          small
          left
        >
          check
        </v-icon>
        Save
      </v-btn>
    </template>
    <!--</editor-fold>-->
  </content-dialog>
</template>

<script>
import Yacht from '@/models/Yacht'
import ContentDialog from '@/components/helpers/Dialog'
import AssigneeModalSelect from '@/components/service/helpers/AssigneeModalSelect'

export default {
  name: 'YachtSalesRepEditDialog',
    components: {
      AssigneeModalSelect,
      ContentDialog
    },
    props: {
      visible: Boolean,
      yacht: {
        type: Object,
        default: () => Yacht.emptyModel
      }
    },
    data() {
      return {
        salesRep: undefined,
        submitting: false
      }
    },
    computed: {
      modalVisible: {
        get: function () {
          return this.visible
        },
        set: function (value) {
          this.$emit('update:visible', value)
        }
      }
    },
    created() {
      this.salesRep = this.yacht.sales_rep
    },
    methods: {
      async submit() {
        let validation = await this.$validator.validate()

        if (!validation) return

        this.saveYacht()
      },
      async saveYacht() {
        this.submitting = true

        let formData = {
          sales_rep_id: this.salesRep.id
        }

        try {
          let savedYacht = await Yacht.api.save(formData, this.yacht.id)

          this.$store.dispatch('alert', {
            'text': 'Sales Representative Updated',
            'color': 'success'
          })
          this.$emit('update:yacht', savedYacht)
          this.modalVisible = false
        } catch (e) {
          if (e.response && e.response.status === 422) {
            this.$store.dispatch('alert', {
              'text': e.response.data.message,
              'color': 'warning'
            })
          } else {
            this.$store.dispatch('alert', {
              'text': 'Something went wrong',
              'color': 'error'
            })
          }

          throw e
        } finally {
          this.submitting = false
        }
      }
    }
  }
</script>
